var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionalism(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    xmlns: "http://www.w3.org/2000/svg",
    height: 43,
    id: "screenshot-2bd33f28-acce-8023-8007-4569d77e8d9d",
    viewBox: "0 0 43 43",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8d9d"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame-clip-2bd33f28-acce-8023-8007-4569d77e8d9d-render-1",
    className: "frame-clip frame-clip-def"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 43.00000000000023,
    height: 42.99999999999994,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame-clip-2bd33f28-acce-8023-8007-4569d77e8d9d-render-1)",
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8d9d"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 43.00000000000023,
    height: 42.99999999999994,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8d9e",
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8d9f",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8d9f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.30000000000018,
    height: 42.299999999999955,
    x: -0.4082299216224783,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: -0.04487239495392714
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8da0"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "rgb(0, 0, 0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8da1",
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8da2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8da2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3818359375,28.325103759765625C32.99169921875,28.325103759765625,32.661865234375,27.995086669921875,32.661865234375,27.615081787109375L32.661865234375,18.795135498046875C32.661865234375,18.415130615234375,32.99169921875,18.085113525390625,33.3818359375,18.085113525390625C33.771728515625,18.085113525390625,34.101806640625,18.415130615234375,34.101806640625,18.795135498046875L34.101806640625,27.675079345703125C34.101806640625,28.005096435546875,33.771728515625,28.325103759765625,33.3818359375,28.325103759765625Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(195, 195, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8da3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8da3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.251708984375,6.915130615234375C30.191650390625,6.915130615234375,30.961669921875,7.675079345703125,30.961669921875,8.605133056640625C30.961669921875,9.535125732421875,30.191650390625,10.295135498046875,29.251708984375,10.295135498046875C28.311767578125,10.295135498046875,27.541748046875,9.535125732421875,27.541748046875,8.605133056640625C27.541748046875,7.675079345703125,28.311767578125,6.915130615234375,29.251708984375,6.915130615234375Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-c5f47f4a-f2da-8026-8007-4677f56e99cc-2bd33f28-acce-8023-8007-4569d77e8da3",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.251708984375,6.915130615234375C30.191650390625,6.915130615234375,30.961669921875,7.675079345703125,30.961669921875,8.605133056640625C30.961669921875,9.535125732421875,30.191650390625,10.295135498046875,29.251708984375,10.295135498046875C28.311767578125,10.295135498046875,27.541748046875,9.535125732421875,27.541748046875,8.605133056640625C27.541748046875,7.675079345703125,28.311767578125,6.915130615234375,29.251708984375,6.915130615234375Z",
    style: {
      fill: "none",
      strokeWidth: 0.75,
      stroke: "rgb(255, 144, 0)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8da4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8da4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6318359375,24.235137939453125C9.40185546875,24.235137939453125,10.01171875,24.835113525390625,10.01171875,25.595123291015625C10.01171875,26.355133056640625,9.40185546875,26.955108642578125,8.6318359375,26.955108642578125C7.86181640625,26.955108642578125,7.26171875,26.355133056640625,7.26171875,25.595123291015625C7.26171875,24.835113525390625,7.86181640625,24.235137939453125,8.6318359375,24.235137939453125Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-c5f47f4a-f2da-8026-8007-4677f56f6bd1-2bd33f28-acce-8023-8007-4569d77e8da4",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6318359375,24.235137939453125C9.40185546875,24.235137939453125,10.01171875,24.835113525390625,10.01171875,25.595123291015625C10.01171875,26.355133056640625,9.40185546875,26.955108642578125,8.6318359375,26.955108642578125C7.86181640625,26.955108642578125,7.26171875,26.355133056640625,7.26171875,25.595123291015625C7.26171875,24.835113525390625,7.86181640625,24.235137939453125,8.6318359375,24.235137939453125Z",
    style: {
      fill: "none",
      strokeWidth: 0.5,
      stroke: "rgb(255, 144, 0)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8da5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8da5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.751708984375,21.495086669921875L20.291748046875,25.295135498046875C20.731689453125,25.565093994140625,21.28173828125,25.565093994140625,21.7216796875,25.295135498046875L29.26171875,21.495086669921875L29.26171875,29.515106201171875C29.26171875,30.335113525390625,28.601806640625,31.045135498046875,27.7216796875,31.045135498046875L14.3017578125,31.045135498046875C13.4716796875,31.045135498046875,12.76171875,30.395111083984375,12.76171875,29.515106201171875L12.76171875,21.495086669921875Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(120, 120, 120)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8da6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8da6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1318359375,13.995086669921875C36.521728515625,13.995086669921875,36.841796875,14.325103759765625,36.841796875,14.705108642578125C36.841796875,15.085113525390625,36.51171875,15.415130615234375,36.1318359375,15.415130615234375C35.751708984375,15.415130615234375,35.411865234375,15.085113525390625,35.411865234375,14.705108642578125C35.4716796875,14.325103759765625,35.74169921875,13.995086669921875,36.1318359375,13.995086669921875Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(195, 195, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8da7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8da7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.331787109375,33.275115966796875C22.7216796875,33.275115966796875,23.0517578125,33.605133056640625,23.0517578125,33.985137939453125C23.0517578125,34.365081787109375,22.7216796875,34.695098876953125,22.331787109375,34.695098876953125C21.941650390625,34.695098876953125,21.61181640625,34.365081787109375,21.61181640625,33.985137939453125C21.671875,33.545135498046875,21.941650390625,33.275115966796875,22.331787109375,33.275115966796875Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(228, 126, 63)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8da8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8da8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.191650390625,7.895111083984375C15.581787109375,7.895111083984375,15.911865234375,8.225128173828125,15.911865234375,8.605133056640625C15.911865234375,8.985137939453125,15.581787109375,9.315093994140625,15.191650390625,9.315093994140625C14.8017578125,9.315093994140625,14.4716796875,8.985137939453125,14.4716796875,8.605133056640625C14.53173828125,8.225128173828125,14.8017578125,7.895111083984375,15.191650390625,7.895111083984375Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(195, 195, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8da9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8da9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.191650390625,34.695098876953125C15.581787109375,34.695098876953125,15.911865234375,35.025115966796875,15.911865234375,35.405120849609375C15.911865234375,35.785125732421875,15.581787109375,36.115081787109375,15.191650390625,36.115081787109375C14.8017578125,36.115081787109375,14.481689453125,35.785125732421875,14.481689453125,35.405120849609375C14.481689453125,34.965118408203125,14.811767578125,34.695098876953125,15.191650390625,34.695098876953125Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(152, 152, 152)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8daa"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8daa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.251708984375,11.275115966796875C7.641845703125,11.275115966796875,7.961669921875,11.605133056640625,7.961669921875,11.985137939453125C7.961669921875,12.365081787109375,7.6318359375,12.695098876953125,7.251708984375,12.695098876953125C6.871826171875,12.695098876953125,6.53173828125,12.365081787109375,6.53173828125,11.985137939453125C6.591796875,11.605133056640625,6.86181640625,11.275115966796875,7.251708984375,11.275115966796875Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(228, 126, 63)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8dab"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8dab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.541748046875,16.995086669921875C34.421875,17.535125732421875,34.421875,18.795135498046875,33.541748046875,19.335113525390625C33.49169921875,19.385101318359375,21.771728515625,26.675079345703125,21.711669921875,26.675079345703125C21.271728515625,26.945098876953125,20.7216796875,26.945098876953125,20.28173828125,26.675079345703125C20.28173828125,26.675079345703125,8.561767578125,19.385101318359375,8.45166015625,19.335113525390625C7.57177734375,18.795135498046875,7.57177734375,17.535125732421875,8.45166015625,16.995086669921875L20.28173828125,10.695098876953125C20.7216796875,10.425079345703125,21.271728515625,10.425079345703125,21.711669921875,10.695098876953125L33.541748046875,16.995086669921875Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(152, 152, 152)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8dac"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8dac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6318359375,12.745086669921875C20.021728515625,12.745086669921875,20.351806640625,13.075103759765625,20.351806640625,13.455108642578125C20.351806640625,13.835113525390625,20.021728515625,14.165130615234375,19.6318359375,14.165130615234375C19.24169921875,14.165130615234375,18.921875,13.835113525390625,18.921875,13.455108642578125C18.9716796875,13.015106201171875,19.251708984375,12.745086669921875,19.6318359375,12.745086669921875Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(84, 91, 102)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8dad"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8dad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.90185546875,18.565093994140625C11.681884765625,18.565093994140625,11.461669921875,18.455108642578125,11.291748046875,18.235137939453125C11.07177734375,17.905120849609375,11.181884765625,17.475128173828125,11.51171875,17.305084228515625L17.20166015625,14.165130615234375C17.53173828125,13.945098876953125,17.9716796875,14.055084228515625,18.141845703125,14.385101318359375C18.36181640625,14.715118408203125,18.251708984375,15.145111083984375,17.921875,15.315093994140625L12.231689453125,18.455108642578125C12.121826171875,18.565093994140625,12.01171875,18.565093994140625,11.90185546875,18.565093994140625Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(84, 91, 102)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8dae"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8dae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3818359375,27.615081787109375C34.15185546875,27.615081787109375,34.76171875,28.215118408203125,34.76171875,28.975128173828125C34.76171875,29.735137939453125,34.161865234375,30.335113525390625,33.3818359375,30.335113525390625C32.601806640625,30.335113525390625,32.001708984375,29.735137939453125,32.001708984375,28.975128173828125C32.001708984375,28.215118408203125,32.61181640625,27.615081787109375,33.3818359375,27.615081787109375Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(120, 120, 120)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569d77e8daf"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569d77e8daf"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.741770078377613,
    cy: 21.10512760504605,
    rx: 20.90000000000009,
    ry: 20.899999999999977,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-c5f47f4a-f2da-8026-8007-4677f5729844-2bd33f28-acce-8023-8007-4569d77e8daf",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.741770078377613,
    cy: 21.10512760504605,
    rx: 20.90000000000009,
    ry: 20.899999999999977,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none",
      strokeWidth: 0.5,
      stroke: "rgb(244, 140, 78)",
      strokeOpacity: 1
    }
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalism);
export default __webpack_public_path__ + "static/media/professionalism.61edab6c98ce6abcdcd852d65e7a0b74.svg";
export { ForwardRef as ReactComponent };